// Adresse du site dédié Giulia (projet Emergent séparé).
// Seul endroit à modifier quand l'adresse finale est connue.
// Temporairement : la page interne /giulia (non liée dans la navigation).
export const GIULIA_SITE_URL = "/giulia";
